import { render, staticRenderFns } from "./BannerMarketComp.vue?vue&type=template&id=0c6fcb8f&scoped=true&"
import script from "./BannerMarketComp.vue?vue&type=script&lang=js&"
export * from "./BannerMarketComp.vue?vue&type=script&lang=js&"
import style0 from "./BannerMarketComp.vue?vue&type=style&index=0&id=0c6fcb8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6fcb8f",
  null
  
)

export default component.exports